import React from 'react';
import style from './loyaltyTermsAndConditionsModal.module.scss';
import { Modal } from '../common/modal';
import { LoyaltyTermsAndConditionsPageContent } from './loyaltyTermsAndConditionsPageContent';
import { FormattedMessage } from 'react-intl';
import { GoBackLink } from '../common/goBackLink';

interface LoyaltyTermsAndConditionsModalProps {
    acknowledgeLoyaltyTermsAndConditions: () => void;
}

class LoyaltyTermsAndConditionsModal extends React.Component<LoyaltyTermsAndConditionsModalProps, {}> {
    render(): JSX.Element {
        return (
            <div>
                <Modal
                    isOpen={true}
                    closeModal={() => {}}
                    modalHeaderContent={
                        <FormattedMessage
                            id={'components.loyalty.loyaltyTermsAndConditionsModal.title'}
                            defaultMessage={'My Rewards Terms And Conditions'}
                        />}
                    closingModalClassName={style.HideCloseButton}
                >
                    <div className={style.TsAndCsContainer}>
                        <LoyaltyTermsAndConditionsPageContent />
                    </div>
                    <div className={style.ButtonsContainer}>
                        <GoBackLink className={style.BackButton} fallbackAddress={`/trip`}>
                            <FormattedMessage
                                id={'components.loyalty.loyaltyTermsAndConditionsModal.back'}
                                defaultMessage={'BACK'}
                            />
                        </GoBackLink>
                        <button
                            className={style.AgreeButton}
                            onClick={() => {
                                this.props.acknowledgeLoyaltyTermsAndConditions();
                            }}
                        >
                            <FormattedMessage
                                id={'components.loyalty.loyaltyTermsAndConditionsModal.agree'}
                                defaultMessage={'I Agree'}
                            />
                        </button>
                    </div>
                </Modal>
            </div>
        );
    }
}

export {LoyaltyTermsAndConditionsModal};
